import React, {useEffect} from 'react'
import axios from "axios"

export default function Paypal({sku, onSuccess, onStartTransaction, onError}) {    
    useEffect(() => {

        window.paypal.Buttons({
            style: {
                layout:  'vertical',
                color:   'blue',
                shape:   'rect',
                label:   'buynow'
            },
            createOrder: function(data,actions) {            
                return axios.post('createpayment',{sku:sku})
                .then(res=>{
                    //console.log("orderid:",res.data.payload.orderid);
                    return res.data.payload.orderid;
                    
                })
                .catch(err=>{
                    console.log(err);
                });                                      
            },
            onApprove: function (data, actions) {
                // Authorize the transaction
                onStartTransaction();
                actions.order.authorize().then(function(authorization) {
                    // Get the authorization id
                    var authorizationID = authorization.purchase_units[0].payments.authorizations[0].id;

                    // Call server to validate and capture the transaction
                    return axios.post('executepayment',{
                        payerid: data.payerID,
                        orderid: data.orderID,
                        authorizationid: authorizationID,
                        sku: sku
                      })
                      .then(res=>{
                        console.log("Paypal result:",res);
                        if (res.data.code===200) {
                            onSuccess(res.data.payload.orderid);
                        }
                        if (res.data.code===404) {
                            onError(res.data.payload.error);
                        }
                      })
                      .catch(err=>{
                        console.log(err);
                        onError(err);
                    }); 

                });
               
            },
            onCancel: function (data) {
                // Show a cancel page, or return to cart
                // console.log("onCancel:",data);
            },
            onError: (err) => {
                console.error('error from the onError callback', err);
            }                     
        }).render("#paypal-button");

        return () => {            
        }
    }, [onError,onStartTransaction,onSuccess,sku])
    return (
        <div>
            <div id="paypal-button"></div>
        </div>
    )
}


